import utils from "utils"


export default {
  state: {
    score:  utils.store.getStorage('score') || '',
    advice: null,
    reason: null,
    page: 'normal'
  },

  setVip (status) {
    this._setPage(status ? 'vip' : 'normal')
    this.state.vip = status
  },

  _setPage (page) {
    this.state.page = page
  },

  setScore (score) {
    this.state.score = score
    utils.store.setStorage('score', score)
  },

  getScore() {
    return this.state.score
  },

  getVip () {
    return this.state.vip
  },

  getPage () {
    return this.state.page
  },

  setAdvice(advice) {
    this.state.advice = advice
  },

  setReason(reason) {
    this.state.reason = reason
  },

  getReason() {
    return this.state.reason
  },

  getAdvice() {
    return this.state.advice
  },
}
